import React, { useState, useEffect } from 'react';
import './ColumnOptions.css';
import apiService from '../../services/api.js';

const viewIcon = apiService.getBlobAssetUrl('View.svg');
const hideIcon = apiService.getBlobAssetUrl('Hide.svg');

const ColumnOptions = ({ columns, onSave }) => {
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);

  useEffect(() => {
    const initialColumns = columns.filter(col => col.visible);
    setSelectedColumns(initialColumns);
    const allColumns = columns.map(col => ({ ...col, visible: initialColumns.some(c => c.key === col.key) }));
    setAvailableColumns(allColumns);
  }, [columns]);

  const handleColumnVisibility = (key) => {
    setSelectedColumns(prev => 
      prev.some(col => col.key === key)
        ? prev.filter(col => col.key !== key)
        : [...prev, availableColumns.find(col => col.key === key)]
    );
  };

  const handleSave = () => {
    const updatedColumns = availableColumns.map(col => ({
      ...col,
      visible: selectedColumns.some(sc => sc.key === col.key)
    }));
    onSave(updatedColumns);
  };

  return (
    <div className="column-options-backdrop">
      <div className="column-options-popup">
        <div className="column-options-header">
          <h3>Column Options</h3>
          <button className="close-button" onClick={() => onSave(null)}>×</button>
        </div>
        <div className="column-options-content">
          <p>To View/Hide the Columns,Click on Icons.</p>
          {availableColumns.map(col => (
            <div key={col.key} className="column-option">
              <span>{col.label}</span>
              <button
                onClick={() => handleColumnVisibility(col.key)}
                className="visibility-toggle"
              >
                <img
                  src={selectedColumns.some(sc => sc.key === col.key) ? viewIcon : hideIcon}
                  alt={selectedColumns.some(sc => sc.key === col.key) ? 'View' : 'Hide'}
                  className="visibility-icon"
                />
              </button>
            </div>
          ))}
        </div>
        <div className="column-options-footer">
          <button onClick={() => onSave(null)}>Cancel</button>
          <button onClick={handleSave}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default ColumnOptions;